import { useState, useEffect } from 'react';
import { Heart, Trash2 } from 'lucide-react';
import { api, formatApiError } from '../lib/api';
import { ListingCard, ListingCardSkeleton } from '../components/ListingCard';
import { toast } from 'sonner';

export default function FavoritesPage() {
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadFavorites();
  }, []);

  const loadFavorites = async () => {
    try {
      const data = await api.getFavorites();
      setFavorites(data.map(f => ({ ...f, is_favorited: true })));
    } catch (e) {
      console.error('Error loading favorites:', e);
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveFavorite = async (listingId) => {
    try {
      await api.removeFavorite(listingId);
      setFavorites(favorites.filter(f => f.id !== listingId));
      toast.success('Eliminado de favoritos');
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0C] pt-24 pb-16" data-testid="favorites-page">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-8">
          <h1 className="text-3xl md:text-4xl font-light tracking-tight text-zinc-100 mb-2 font-[Outfit]">
            Mis favoritos
          </h1>
          <p className="text-zinc-500">{favorites.length} animales guardados</p>
        </div>

        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[...Array(4)].map((_, i) => <ListingCardSkeleton key={i} />)}
          </div>
        ) : favorites.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {favorites.map(listing => (
              <ListingCard 
                key={listing.id} 
                listing={listing}
                onFavorite={handleRemoveFavorite}
              />
            ))}
          </div>
        ) : (
          <div className="text-center py-20 glass-card">
            <Heart className="w-12 h-12 text-zinc-600 mx-auto mb-4" />
            <h2 className="text-xl font-medium text-zinc-100 mb-2">No tienes favoritos</h2>
            <p className="text-zinc-500">Explora el marketplace y guarda los animales que te interesen</p>
          </div>
        )}
      </div>
    </div>
  );
}
